module.exports = parcelRequire.resolve("6HS2M");